<template>
  <span>
    <div v-for="(outlet, index) in outletInformation" :key="index">
      <title>{{ outlet.name }}</title>
      <link rel="icon" :href="outlet.logo" />
    </div>
    <div class="header-container">
      <div class="container">
        <div class="header-sub-container">
          <div class="header-left" v-for="(outlet, index) in outletInformation" :key="index">
            <a href="/">
              <img :src="outlet.logo" class="logo" :alt="outlet.name" />
            </a>
          </div>
          <div class="header-right">
            {
            <router-link to="/contact" class="contact-btn comombackground">Contact Us</router-link>
            <a v-if="userinfolocal == ''" @click="openModalLogin" name="btn_login" class="login-btn"
              value="Login">Login</a>
            <div v-if="userinfolocal != ''" class="dropdown">
              <a class="header-right-drop">
                <i class="fa fa-user" aria-hidden="true"></i>{{ userinfolocal.name }}
                <i class="fa fa-caret-down"></i>
              </a>
              <div class="dropdown-content">
                <a style="text-align: left; background: #343a40; color: #fff">
                  <i class="fa fa-user" aria-hidden="true"></i>
                  &nbsp;&nbsp;&nbsp;&nbsp;{{ userinfolocal.name }}
                </a>
                <a @click="updateprofilemodal"><i class="fa fa-user" aria-hidden="true"></i>
                  &nbsp;&nbsp;&nbsp;&nbsp;Profile</a>
                <a @click="changepasswordmodal" style="text-align: left"><i class="fa fa-lock" aria-hidden="true"></i>
                  &nbsp;&nbsp;&nbsp;&nbsp;Change Password</a>
                <router-link to="/order" style="text-align: left"><i class="fa fa-shopping-cart" aria-hidden="true"></i>
                  &nbsp;&nbsp;&nbsp;&nbsp;View Orders</router-link>
                <a @click="logoutuser" style="text-align: left"><i class="fa fa-sign-out" aria-hidden="true"></i>
                  Logout
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-sm-login" hide-header hide-footer scrollable>
      <div class="modal-body">
        <div class="modal-close-btn">
          <span @click="closeLoginModal">&times;</span>
        </div>
        <div class="modal-body-sub-container">
          <b-col v-if="getFormName == 'loginwithotp'">
            <div class="modal-body-title">
              <h5>Mobile Number Verification</h5>
            </div>
            <div class="modal-body-form">
              <b-form-input class="form-control" v-if="email_login == 0" v-model="user_mobile_otp"
                placeholder="Mobile Number" type="number"></b-form-input>
              <b-form-input class="form-control" v-if="email_login == 1" v-model="user_mobile_otp"
                placeholder="Enter Your Mobile Number or email" type="text"></b-form-input>
            </div>
            <div class="extra-login-btns">
              <b-button class="login-button" @click="showForm('loginwithpassword')">Login with Password </b-button>
              <b-button class="login-button" @click="showForm('signup')">New User</b-button>
            </div>
            <b-button class="modal-submit-btn" @click="sendOTP('otpform')" block>Send OTP</b-button>
          </b-col>
          <b-col v-if="getFormName == 'confirmotp'">
            <div class="modal-body-title">
              <h5>Verify OTP</h5>
              <p>Hello, {{ conotpname }}</p>
            </div>
            <div class="modal-body-form">
              <b-form-input class="form-control" id="number" placeholder="Enter OTP Here" v-model="otp" type="number">
              </b-form-input>
            </div>
            <b-button class="modal-submit-btn" block @click="verifyOTP">Verify OTP</b-button>
          </b-col>
          <b-col v-if="getFormName == 'updateprofile'">
            <div class="modal-body-title">
              <h5>Edit Profile</h5>
            </div>
            <div class="modal-body-form">
              <b-form-input class="form-control" id="password" @input="changename" v-model="updatename"
                placeholder="Enter Name" type="text"></b-form-input>
              <b-form-input class="form-control" id="password" v-model="updateaddress" placeholder="Enter Address"
                type="text"></b-form-input>
            </div>
            <b-button class="modal-submit-btn" block @click="updateProfile">Update Profile</b-button>
          </b-col>
          <b-col v-if="getFormName == 'changepwd'">
            <div class="modal-body-title">
              <h5>Edit Password</h5>
            </div>
            <div class="extra-login-btns1">
              <b-button class="login-button" @click="getOTP">Get OTP</b-button>
            </div>
            <div class="modal-body-form">
              <b-form-input class="form-control" v-model="change_pass_otp" id="number" placeholder="OTP" type="number">
              </b-form-input>
              <b-form-input class="form-control" v-model="change_pass_newpwd" id="newpwd" placeholder="New Password"
                type="password"></b-form-input>
              <b-form-input class="form-control" v-model="change_pass_conpwd" id="conpwd" placeholder="Confirm Password"
                type="password"></b-form-input>
            </div>
            <b-alert v-if="error_show != ''" show variant="danger">{{ error_show }}</b-alert>
            <b-button class="modal-submit-btn" block @click="changePassword">Change Password</b-button>
          </b-col>
          <b-col v-if="getFormName == 'verifycust'">
            <div class="modal-body-title">
              <h5>Hello, {{ conotpname }}</h5>
            </div>
            <div class="modal-body-form">
              <b-form-input class="form-control" id="verifycust" placeholder="Enter OTP Here" v-model="verifycustregi"
                autocomplete="off" type="number"></b-form-input>
            </div>
            <b-button class="modal-submit-btn" block @click="verifycust">Verify OTP</b-button>
          </b-col>
          <b-col v-if="getFormName == 'loginwithpassword'">
            <div class="modal-body-title">
              <h5>Login</h5>
            </div>
            <div class="extra-login-btns1">
              <b-button class="login-button" @click="showForm('forgetpwd')">Forget Password</b-button>
              <b-button class="login-button" @click="showForm('signup')">New User</b-button>
            </div>
            <div class="modal-body-form">
              <b-form-input class="form-control" id="number" v-model="loginwithmobilenumber"
                placeholder="Enter Your Mobile Number" type="number"></b-form-input>
              <b-form-input class="form-control" id="password" v-model="loginwithpass" placeholder="Enter Password"
                type="password"></b-form-input>
            </div>
            <b-button class="modal-submit-btn" block @click="loginWithPassword">Login</b-button>
          </b-col>
          <b-col v-if="getFormName == 'signup'">
            <div class="modal-body-title">
              <h5>New User Registration</h5>
            </div>
            <div class="extra-login-btns1">
              <b-button class="login-button" @click="showForm('loginwithpassword')">Login</b-button>
            </div>
            <div class="modal-body-form">
              <b-form-input class="form-control" id="user_mobile_number" placeholder="Mobile Number"
                v-model="signupform.user_mobile_number" type="number"></b-form-input>
              <b-form-input class="form-control" id="user_name" placeholder="Name" v-model="signupform.user_name"
                type="text"></b-form-input>
              <b-form-input class="form-control" v-if="ask_dob_while_registration == 1" type="text"
                onfocus="(this.type='date')" id="user_dob" v-model="signupform.user_dob"
                placeholder="User Date of Birth" name="birthday"></b-form-input>
              <b-form-input class="form-control" v-if="ask_anniversary_while_registration == 1" type="text"
                onfocus="(this.type='date')" id="example-datepicker_anniverasary" name="user_anniversary"
                v-model="signupform.user_anniversary" placeholder="User Anniversary Date"></b-form-input>
              <b-form-input class="form-control" v-if="ask_email_while_registration == 1" id="user_email_id"
                placeholder="Email Address" v-model="signupform.user_email_id" type="email"></b-form-input>
              <!-- <GmapAutocomplete class="form-control" placeholder="Enter Location" :value="map_address" @input="value = $event.target.value" @place_changed="setPlace"> </GmapAutocomplete> -->
              <b-form-input class="form-control" id="password" placeholder="Password" v-model="signupform.password"
                type="password"></b-form-input>
              <b-form-input class="form-control" id="confirm_password" placeholder="Confirm Password"
                v-model="signupform.confirm_password" type="password"></b-form-input>
            </div>
            <b-button class="modal-submit-btn" block @click="registerUser">Register</b-button>
          </b-col>
          <b-col v-if="getFormName == 'forgetpwd'">
            <div class="modal-body-title">
              <h5>Forget Password</h5>
            </div>
            <div class="extra-login-btns1">
              <b-button class="login-button" @click="showForm('loginwithpassword')">Login</b-button>
              <b-button class="login-button" @click="getOTP">Get OTP</b-button>
            </div>
            <div class="modal-body-form">
              <b-form-input class="form-control" v-model="otp" id="number" placeholder="OTP"></b-form-input>
              <b-form-input class="form-control" v-model="newpwd" id="newpwd" placeholder="New Password"
                type="password"></b-form-input>
              <b-form-input class="form-control" v-model="conpwd" id="conpwd" placeholder="Confirm Password"
                type="password"></b-form-input>
            </div>
            <b-alert v-if="error_show != ''" show variant="danger">{{ error_show }}</b-alert>
            <b-button class="modal-submit-btn" block @click="forgetPassword">Submit</b-button>
          </b-col>
        </div>
      </div>
    </b-modal>
  </span>
</template>

<script>
//import logo from "../assets/images/logo.jpg"
import { mapGetters } from "vuex";

export default {
  name: "Header",
  data () {
    return {
      formShow: "",
      signupform: [
        "user_mobile_number",
        "user_name",
        "user_address",
        "password",
        "confirm_password",
        "user_dob",
        "user_anniversary",
        "user_email_id",
      ],
      conotpname: "",
      conotpnumber: "",
      storeid: "",
      otp: "",
      userdata: [],
      otpdata: [],
      user_mobile_otp: "",
      verify_otp_while_registration: "",
      loginwithmobilenumber: "",
      loginwithpass: "",
      userinfolocal: localStorage.getItem("userinfo")
        ? JSON.parse(localStorage.getItem("userinfo"))
        : [],
      newpwd: "",
      conpwd: "",
      error_show: "",
      logo: "",
      ask_dob_while_registration: 0,
      ask_anniversary_while_registration: 0,
      updatename: "",
      updateaddress: "",
      updatedname: "",
      login_method: "",
      verifycustregi: "",
      change_pass_otp: "",
      change_pass_newpwd: "",
      change_pass_conpwd: "",
      address: "",
      ask_email_while_registration: "",
      email_login: "",
      emailvalue: "",
      otpvalue: "",
    };
  },
  computed: {
    ...mapGetters(["cartItemCount"]),
    ...mapGetters(["outletInformation"]),
    ...mapGetters(["cartItems"]),
    ...mapGetters(["digital_order_setting"]),
    ...mapGetters(["getFormName"]),
  },
  methods: {
    /* setAddress(map_address) {
      // alert(map_address);
      this.signupform.user_address = map_address;
    }, */
    closeLoginModal () {
      this.$bvModal.hide("modal-sm-login");
    },
    openModalLogin () {
      this.signupform.user_name = "";
      this.signupform.user_mobile_number = "";
      this.signupform.user_address = "";
      this.signupform.password = "";
      this.signupform.confirm_password = "";
      this.signupform.user_dob = "";
      this.signupform.user_anniversary = "";
      this.signupform.user_email_id = "";

      this.updatename = "";
      this.updateaddress = "";
      this.user_mobile_otp = "";
      this.otp = "";
      this.verifycustregi = "";
      this.loginwithmobilenumber = "";
      this.loginwithpass = "";
      this.newpwd = "";
      this.conpwd = "";
      this.change_pass_otp = "";
      this.change_pass_newpwd = "";
      this.change_pass_conpwd = "";

      let currentObj = this;

      //alert("hello "+ currentObj.digital_order_setting.login_method)
      if (currentObj.digital_order_setting.login_method == 2) {
        currentObj.formShow = "loginwithpassword";
        // this.userinfolocal = JSON.parse(localStorage.getItem('userinfo'))

        this.$store.dispatch("setFormName", "loginwithpassword");
      } else {
        currentObj.formShow = "loginwithotp";

        this.$store.dispatch("setFormName", "loginwithotp");
      }

      this.outletInformation.forEach((item) => {
        this.ask_dob_while_registration =
          item.digital_ordering_settings.customer.ask_dob_while_registration;

        this.ask_anniversary_while_registration =
          item.digital_ordering_settings.customer.ask_anniversary_while_registration;
        this.ask_email_while_registration =
          item.digital_ordering_settings.customer.ask_email_while_registration;

        this.email_login = item.digital_ordering_settings.customer.email_login;

        // alert("ask_dob_while_registration "+this.ask_dob_while_registration)
        // alert("ask_anniversary_while_registration "+this.ask_anniversary_while_registration)
      });

      // this.formShow = this.getFormName
      //alert("form is "+ this.formShow)

      //alert('formShow '+ currentObj.formShow)
      //  currentObj.showForm(currentObj.formShow)

      currentObj.$bvModal.show("modal-sm-login");
    },
    logoutuser () {
      // alert("logoutuser")

      localStorage.removeItem("coupan_discount");
      localStorage.removeItem("deliverytype");
      localStorage.removeItem("table_room_no");
      localStorage.removeItem("userinfo");
      localStorage.removeItem("storelat");
      localStorage.removeItem("storelng");
      localStorage.removeItem("userlat");
      localStorage.removeItem("userlng");
      localStorage.removeItem("deliverylimit");
      localStorage.removeItem("deliverylocation");
      localStorage.removeItem("formname");
      localStorage.removeItem("valueforactiveclass");
      localStorage.removeItem("digital_order_setting");
      localStorage.removeItem("del_address");
      localStorage.removeItem("cart");
      localStorage.removeItem("coupon_code_name");
      localStorage.removeItem("coupon_code_type");
      localStorage.removeItem("coupan_code_id");
      localStorage.removeItem("order_later");
      localStorage.removeItem("order_now");
      localStorage.removeItem("ordertime");
      localStorage.removeItem("orderdate");

      this.$store.dispatch("resetCartState");
      this.$store.dispatch("resetMenuItemState");
      this.$store.dispatch("resetOrderState");

      this.$cookie.delete("test");
      this.$router.push("/").catch(() => { });

      window.location.reload(true);
    },
    updateprofilemodal () {
      this.formShow = "updateprofile";
      this.$store.dispatch("setFormName", "updateprofile");
      this.$bvModal.show("modal-sm-login");

      this.updatename = this.userinfolocal.name;
      this.updatedname = "Hello " + this.updatename;
      this.updateaddress = this.userinfolocal.address_line1;
    },

    changepasswordmodal () {
      this.formShow = "changepwd";
      this.$store.dispatch("setFormName", "changepwd");
      this.$bvModal.show("modal-sm-login");

      this.loginwithmobilenumber = this.userinfolocal.phone;
      //  this.updatename = this.userinfolocal.name
      //  this.updatedname = "Hye "+ this.updatename
      // this.updateaddress = this.userinfolocal.address_line1
    },
    changename () {
      this.updatedname = "Hello " + this.updatename;
    },
    updateProfile () {
      let currentObj = this;

      if (currentObj.updatename == "" || currentObj.updatename == undefined) {
        this.$bvToast.toast("Please enter name", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      if (
        currentObj.updateaddress == "" ||
        currentObj.updateaddress == undefined
      ) {
        this.$bvToast.toast("Please enter address", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      if (currentObj.updateaddress.indexOf("@") > -1) {
        this.$bvToast.toast("@ symbol is not allowed", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      currentObj.userdata = {
        id: currentObj.userinfolocal.id,
        store_id: currentObj.userinfolocal.store_id,
        phone: currentObj.userinfolocal.phone,
        name: currentObj.updatename,
        address_line1: currentObj.updateaddress,
        dob: currentObj.userinfolocal.dob,
        anniversary: currentObj.userinfolocal.anniversary,
        cust_type: currentObj.userinfolocal.cust_type,
      };

      currentObj.axios
        .put("customer/", currentObj.userdata)
        .then(function (response) {
          let status = JSON.stringify(response.data.status);

          // console.log(status)

          if (status == 200) {
            currentObj.$bvModal.hide("modal-sm-login");

            currentObj.userinfolocal.name = currentObj.updatename;
            currentObj.userinfolocal.address_line1 = currentObj.updateaddress;

            // currentObj.$router.push("/ViewCartComponent").catch(()=>{});
            currentObj.$bvToast.toast("Profile Updated successfully", {
              variant: "success",
              toaster: "b-toaster-bottom-left",
              solid: true,
            });
          }

          if (status == 204) {
            currentObj.$bvModal.hide("modal-sm-login");

            currentObj.userinfolocal.name = currentObj.updatename;
            currentObj.userinfolocal.address_line1 = currentObj.updateaddress;

            // currentObj.$router.push("/ViewCartComponent").catch(()=>{});
            currentObj.$bvToast.toast("Profile Updated successfully", {
              variant: "success",
              toaster: "b-toaster-bottom-left",
              solid: true,
            });
          }
        })
        .catch((error) => {
          //this.errorMessage = error.message;
          console.log("There was an error! " + error);
        });
    },
    showLogin () {
      this.userinfolocal = JSON.parse(localStorage.getItem("userinfo"));

      if (this.userinfolocal == null) {
        /* if(this.userinfolocal.name !== null)
          {
            console.log(this.userinfolocal.name)
             
          }*/
        this.$bvModal.show("modal-sm-login");
      } else {
        // this.$router.push("/ViewCartComponent").catch(()=>{});
      }
    },
    showForm (formname) {
      if (formname === "forgetpwd") {
        //alert("forgetpwd "+formname)

        if (this.loginwithmobilenumber != "") {
          this.formShow = formname;

          this.$store.dispatch("setFormName", formname);
        } else {
          this.$bvToast.toast("Please enter mobile number", {
            variant: "danger",
            toaster: "b-toaster-bottom-left",
            solid: true,
          });
        }
      } else {
        if (formname === "signup") {
          this.signupform.user_mobile_number = this.loginwithmobilenumber;
        }

        this.formShow = formname;
        //alert("hello "+ this.formShow)

        this.$store.dispatch("setFormName", formname);
      }

      //  this.$store.dispatch('setFormName', formname)
    },
    sendOTP (formname) {
      //"newuser"
      //otpform

      /*  // alert("uservalue ", this.user_mobile_otp);
      let value = this.user_mobile_otp;
      value = value.trim();
      var validRegex =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

      let result = value.match(validRegex);
     // alert("result ", result);
      result ? (this.emailvalue = value) : (this.otpvalue = value);

      result ? (this.emailvalue = "") : (this.otpvalue = ""); */

      //return;
      this.outletInformation.forEach((item) => {
        this.verify_otp_while_registration =
          item.digital_ordering_settings.customer.verify_otp_while_registration;

        this.storeid = item.store_id;
        this.email_login = item.digital_ordering_settings.customer.email_login;
        // alert(this.storeid)
      });

      //  alert("this.user_mobile_otp ", this.user_mobile_otp);

      let currentObj = this;

      if (this.user_mobile_otp == "") {
        this.user_mobile_otp = this.signupform.user_mobile_number;
      }

      var val = this.user_mobile_otp;

      if (
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          val
        )
      ) {
        // value is ok, use it
        // alert("Valid")
        this.emailvalue = this.user_mobile_otp;
      } else if (/^\d{10}$/.test(val)) {
        this.otpvalue = this.user_mobile_otp;
      } else {
        if (currentObj.email_login == 1) {
          currentObj.$bvToast.toast(
            "Invalid mobile number or email. Please enter valid mobile number or email",
            {
              variant: "danger",
              toaster: "b-toaster-bottom-left",
              solid: true,
            }
          );
          return;
        }

        if (currentObj.email_login == 0) {
          currentObj.$bvToast.toast(
            "Invalid mobile number. Please enter valid mobile number",
            {
              variant: "danger",
              toaster: "b-toaster-bottom-left",
              solid: true,
            }
          );
          return;
        }
      }

      /*  alert("otpvalue ", this.otpvalue);
      alert("emailvalue ", this.emailvalue); */

      currentObj.outletInformation.forEach((item) => {
        currentObj.verify_otp_while_registration =
          item.digital_ordering_settings.customer.verify_otp_while_registration;
      });

      //alert("user_mobile_otp ", this.user_mobile_otp);
      currentObj.otpdata = {
        store_id: this.storeid,
        phone: this.otpvalue,
        email: this.emailvalue,
        sendotpVia: 1
      };

      currentObj.axios
        .post("otp/", this.otpdata)
        .then(function (response) {
          let status = JSON.stringify(response.data.status);
          let type = JSON.stringify(response.data.type);

          if (status == 404) {
            currentObj.$store.dispatch("setFormName", "signup");

            currentObj.$bvToast.toast(
              "Customer Not Found. Please First Register Your Number",
              {
                variant: "danger",
                toaster: "b-toaster-bottom-left",
                solid: true,
              }
            );
            return;
          }

          if (status == 200 && type.localeCompare('"new"') == 0) {
            if (
              currentObj.otpdata.verify_otp_while_registration == 1 &&
              formname == "newuser"
            ) {
              currentObj.formShow = "verifycust";
              currentObj.$store.dispatch("setFormName", "verifycust");

              currentObj.conotpname = currentObj.signupform.user_name;

              currentObj.conotpnumber =
                "OTP sent to " + currentObj.signupform.user_mobile_number;

              currentObj.$bvToast.toast(
                `OTP sent on  ${currentObj.user_mobile_otp}`,
                {
                  variant: "success",
                  toaster: "b-toaster-bottom-left",
                  solid: true,
                }
              );
              //     localStorage.removeItem("userinfo");

              //alert("Response is "+JSON.stringify(response.data.custinfo))
              /*
                   let tmpStr = JSON.stringify(response.data.custinfo)
                   let newStr = tmpStr.substring(1, tmpStr.length-1);
                  localStorage.setItem("userinfo", newStr)*/
            } else if (formname == "otpform") {
              currentObj.formShow = "signup";
              currentObj.$store.dispatch("setFormName", "signup");
              currentObj.signupform.user_mobile_number =
                currentObj.user_mobile_otp;
            }
          } else if (
            (status == 200 && type.localeCompare('"old"') == 0) ||
            currentObj.otpdata.verify_otp_while_registration == 1
          ) {
            currentObj.formShow = "confirmotp";
            currentObj.$store.dispatch("setFormName", "confirmotp");

            response.data.custinfo.forEach((item) => {
              // alert("name "+item.name)

              currentObj.conotpname = item.name;
              // alert(this.storeid)
            });

            // currentObj.conotpname = currentObj.userdata.name
            currentObj.conotpnumber =
              "OTP sent to " + currentObj.user_mobile_otp;

            currentObj.$bvToast.toast(
              `OTP sent on  ${currentObj.user_mobile_otp}`,
              {
                variant: "success",
                toaster: "b-toaster-bottom-left",
                solid: true,
              }
            );

            //  localStorage.removeItem("userinfo");

            let tmpStr = JSON.stringify(response.data.custinfo);
            var newStr = tmpStr.substring(1, tmpStr.length - 1);
            //  localStorage.setItem("userinfo", newStr)
            currentObj.$cookie.set("test", newStr, 1);
          }
        })
        .catch((error) => {
          //this.errorMessage = error.message;
          console.log("There was an error! " + error);
        });
    },
    registerUser () {
      //alert("address ", this.address);
      var val = this.signupform.user_mobile_number;
      if (/^\d{10}$/.test(val)) {
        // value is ok, use it
        // alert("Valid")
      } else {
        // alert("Invalid number; must be ten digits")

        this.$bvToast.toast(
          "Invalid mobile number. Please enter valid number",
          {
            variant: "danger",
            toaster: "b-toaster-bottom-left",
            solid: true,
          }
        );

        return;
      }

      if (
        this.signupform.user_name == "" ||
        this.signupform.password == undefined
      ) {
        this.$bvToast.toast("Please enter name", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      ///alert(this.signupform.user_address);
      /* if (
        this.signupform.user_address == "" ||
        this.signupform.user_address == undefined
      ) {
        this.$bvToast.toast("Please enter address", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      } */

      if (
        this.signupform.password == "" ||
        this.signupform.password == undefined
      ) {
        this.$bvToast.toast("Please enter password", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      if (
        this.signupform.confirm_password == "" ||
        this.signupform.confirm_password == undefined
      ) {
        this.$bvToast.toast("Please enter confirm password", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      if (this.signupform.confirm_password != this.signupform.password) {
        this.$bvToast.toast("Password and confirm password should be same", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      let currentObj = this;

      currentObj.outletInformation.forEach((item) => {
        currentObj.verify_otp_while_registration =
          item.digital_ordering_settings.customer.verify_otp_while_registration;

        this.storeid = item.store_id;
      });

      currentObj.otpdata = {
        store_id: this.storeid,
        phone: this.signupform.user_mobile_number,
        verify_otp_while_registration: currentObj.verify_otp_while_registration,
      };

      currentObj.userdata = {
        store_id: this.storeid,
        phone: this.signupform.user_mobile_number,
        name: this.signupform.user_name,
        address_line1: this.signupform.user_address,
        dob: this.signupform.user_dob,
        anniversary: this.signupform.user_anniversary,
        password: this.signupform.password,
        verify_otp_while_registration: currentObj.verify_otp_while_registration,
        email: this.signupform.user_email_id,
      };

      // console.log("currentObj.userdata ", JSON.stringify(currentObj.userdata));

      currentObj.axios
        .post("customer/", currentObj.userdata)
        .then(function (response) {
          let status = JSON.stringify(response.data.status);

          let is_registered;
          if (status == 200) {
            is_registered = JSON.stringify(
              response.data.custinfo.is_registered
            );
          }

          if (status == 200 && is_registered == 0) {
            localStorage.setItem(
              "userinfo",
              JSON.stringify(response.data.custinfo)
            );

            currentObj.$cookie.set(
              "test",
              JSON.stringify(response.data.custinfo),
              1
            );
            //alert(status)
            currentObj.sendOTP("newuser");
          }

          if (status == 601) {
            localStorage.setItem(
              "userinfo",
              JSON.stringify(currentObj.userdata)
            );
            //alert(status)
            currentObj.sendOTP("newuser");
          }

          if (status == 200 && is_registered == 1) {
            localStorage.removeItem("userinfo");
            localStorage.setItem(
              "userinfo",
              JSON.stringify(response.data.custinfo)
            );

            currentObj.userinfolocal = JSON.parse(
              localStorage.getItem("userinfo")
            );

            currentObj.$cookie.set(
              "test",
              JSON.stringify(response.data.custinfo),
              1
            );

            currentObj.$bvModal.hide("modal-sm-login");
            // currentObj.$router.push("/ViewCartComponent").catch(()=>{});
            currentObj.$bvToast.toast("Register successfully", {
              variant: "success",
              toaster: "b-toaster-bottom-left",
              solid: true,
            });
          }

          if (status == 204) {
            currentObj.$bvToast.toast(
              "Hey, looks like you're not new to us. Click on forget password if you forget your password",
              {
                variant: "success",
                toaster: "b-toaster-bottom-left",
                solid: true,
              }
            );
            // alert(JSON.stringify(response.data.msg))
          }

          if (status == 422) {
            currentObj.$bvToast.toast("Phone does not exists", {
              variant: "danger",
              toaster: "b-toaster-bottom-left",
              solid: true,
            });
            // alert(JSON.stringify(response.data.msg))
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    verifycust () {
      if (this.verifycustregi == "" || this.verifycustregi == undefined) {
        this.$bvToast.toast("Please enter received otp", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      let currentObj = this;
      currentObj.otpdata["otp"] = currentObj.verifycustregi;

      currentObj.axios
        .post("cust_registered/", currentObj.otpdata)
        .then(function (response) {
          let status = JSON.stringify(response.data.status);
          //let type = JSON.stringify(response.data.type);

          if (status == 200) {
            currentObj.$bvModal.hide("modal-sm-login");
            //  currentObj.$router.push("/ViewCartComponent").catch(()=>{});

            currentObj.$bvToast.toast(response.data.msg, {
              variant: "success",
              toaster: "b-toaster-bottom-left",
              solid: true,
            });

            //alert("userinfolocal "+currentObj.$cookie.get('test'))

            localStorage.setItem("userinfo", currentObj.$cookie.get("test"));
            //alert("Local storage is "+JSON.stringify(localStorage.getItem("userinfo")))
            currentObj.userinfolocal = JSON.parse(
              localStorage.getItem("userinfo")
            );

            /*
//alert("Local storage is "+JSON.stringify(localStorage.getItem("userinfo")))
currentObj.userinfolocal = JSON.parse(localStorage.getItem("userinfo"))


currentObj.$cookie.set('test',JSON.stringify(response.data.custinfo), 1);
*/
            if (currentObj.cartItems.length > 0) {
              // currentObj.$router.push("/checkout").catch(()=>{});
            }
          }

          if (status == 204) {
            currentObj.$bvToast.toast("Invalid OTP", {
              variant: "danger",
              toaster: "b-toaster-bottom-left",
              solid: true,
            });
          }
        })
        .catch((error) => {
          //this.errorMessage = error.message;
          console.log("There was an error! " + error);
        });
    },
    verifyOTP () {
      if (this.otp == "" || this.otp == undefined) {
        this.$bvToast.toast("Please enter received otp", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      let currentObj = this;
      currentObj.otpdata["otp"] = currentObj.otp;

      currentObj.axios
        .post("verifyotp/", currentObj.otpdata)
        .then(function (response) {
          let status = JSON.stringify(response.data.status);
          //let type = JSON.stringify(response.data.type);

          if (status == 200) {
            currentObj.$bvModal.hide("modal-sm-login");
            //  currentObj.$router.push("/ViewCartComponent").catch(()=>{});

            currentObj.$bvToast.toast(response.data.msg, {
              variant: "success",
              toaster: "b-toaster-bottom-left",
              solid: true,
            });

            //alert("userinfolocal "+currentObj.$cookie.get('test'))

            localStorage.setItem("userinfo", currentObj.$cookie.get("test"));
            //alert("Local storage is "+JSON.stringify(localStorage.getItem("userinfo")))
            currentObj.userinfolocal = JSON.parse(
              localStorage.getItem("userinfo")
            );

            //currentObj.$cookie.set('test',JSON.stringify(response.data.custinfo), 1);

            if (currentObj.cartItems.length > 0) {
              // currentObj.$router.push("/checkout").catch(()=>{});
            }
          }

          if (status == 204) {
            currentObj.$bvToast.toast("Invalid OTP", {
              variant: "danger",
              toaster: "b-toaster-bottom-left",
              solid: true,
            });
          }
        })
        .catch((error) => {
          //this.errorMessage = error.message;
          console.log("There was an error! " + error);
        });
    },
    loginWithPassword () {
      //alert("hello")

      var val = this.loginwithmobilenumber;
      if (/^\d{10}$/.test(val)) {
        // value is ok, use it
        // alert("Valid")
      } else {
        // alert("Invalid number; must be ten digits")

        this.$bvToast.toast(
          "Invalid mobile number. Please enter valid number",
          {
            variant: "danger",
            toaster: "b-toaster-bottom-left",
            solid: true,
          }
        );

        return;
      }

      if (this.loginwithpass == "" || this.loginwithpass == undefined) {
        this.$bvToast.toast("Please enter password", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      this.outletInformation.forEach((item) => {
        this.storeid = item.store_id;

        //alert(this.storeid)
      });

      let currentObj = this;
      currentObj.userdata = {
        store_id: this.storeid,
        phone: this.loginwithmobilenumber,
        password: this.loginwithpass,
      };

      currentObj.axios
        .post("loginbypswd", currentObj.userdata)
        .then(function (response) {
          let status = JSON.stringify(response.data.status);
          if (status == 200) {
            currentObj.$bvToast.toast(response.data.msg, {
              variant: "success",
              toaster: "b-toaster-bottom-left",
              solid: true,
            });
            localStorage.setItem(
              "userinfo",
              JSON.stringify(response.data.custinfo)
            );

            currentObj.userinfolocal = JSON.parse(
              localStorage.getItem("userinfo")
            );

            //  alert('currentObj.userinfolocal '+JSON.stringify(response.data.custinfo))
            // From some method in one of your Vue components
            currentObj.$cookie.set(
              "test",
              JSON.stringify(response.data.custinfo),
              1
            );
            // alert(currentObj.userinfolocal.name)
            // currentObj.$router.push("/ViewCartComponent").catch(()=>{});
            currentObj.$bvModal.hide("modal-sm-login");

            if (currentObj.cartItems.length > 0) {
              //  currentObj.$router.push("/checkout").catch(()=>{});
            }
          }

          if (status == 404) {
            currentObj.signupform.user_mobile_number =
              currentObj.loginwithmobilenumber;

            currentObj.formShow = "signup";
            currentObj.$store.dispatch("setFormName", "signup");

            currentObj.$bvToast.toast(response.data.msg, {
              variant: "danger",
              toaster: "b-toaster-bottom-left",
              solid: true,
            });
          }

          if (status == 601) {
            currentObj.user_mobile_otp = currentObj.loginwithmobilenumber;

            currentObj.formShow = "loginwithotp";

            currentObj.$store.dispatch("setFormName", "loginwithotp");
          }

          if (status == 204) {
            // currentObj.formShow = 'signup'
            currentObj.$bvToast.toast(response.data.msg, {
              variant: "danger",
              toaster: "b-toaster-bottom-left",
              solid: true,
            });
          }

          if (status == 201) {
            currentObj.formShow = "forgetpwd";

            currentObj.$store.dispatch("setFormName", "forgetpwd");
          }
        })
        .catch((error) => {
          //this.errorMessage = error.message;
          // alert("There was an error! "+ error);

          console.log(error);
        });
    },
    getOTP () {
      // alert("Send otp method called")
      // alert("Send otp method called")
      let currentObj = this;

      currentObj.outletInformation.forEach((item) => {
        currentObj.verify_otp_while_registration =
          item.digital_ordering_settings.customer.verify_otp_while_registration;

        this.storeid = item.store_id;
      });

      currentObj.otpdata = {
        store_id: this.storeid,
        phone: this.loginwithmobilenumber,
        verify_otp_while_registration: currentObj.verify_otp_while_registration,
      };

      // console.log(JSON.stringify(currentObj.otpdata))

      currentObj.axios
        .post("sendotp/", this.otpdata)
        .then(function (response) {
          let status = JSON.stringify(response.data.status);
          let type = JSON.stringify(response.data.type);

          //console.log(JSON.stringify(response.data.custinfo).substring(1, JSON.stringify(response.data.custinfo).length-1))
          if (status == 200 && type.localeCompare('"new"') == 0) {
            currentObj.formShow = "signup";
            currentObj.$store.dispatch("setFormName", "signup");
            currentObj.signupform.user_mobile_number =
              currentObj.user_mobile_otp;
          }

          if (
            (status == 200 && type.localeCompare('"old"') == 0) ||
            currentObj.otpdata.verify_otp_while_registration == 1
          ) {
            localStorage.setItem(
              "userinfo",
              JSON.stringify(response.data.custinfo).substring(
                1,
                JSON.stringify(response.data.custinfo).length - 1
              )
            );
          }
        })
        .catch((error) => {
          //this.errorMessage = error.message;
          console.log("There was an error! " + error);
        });
    },
    forgetPassword () {
      if (this.otp == "" || this.otp == undefined) {
        this.$bvToast.toast("Please enter received otp", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      if (this.newpwd == "" || this.newpwd == undefined) {
        this.$bvToast.toast("Please enter new password", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      if (this.conpwd == "" || this.conpwd == undefined) {
        this.$bvToast.toast("Please enter confirm password", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      if (this.newpwd != this.conpwd) {
        this.$bvToast.toast(
          "New password and confirm password should be same",
          {
            variant: "danger",
            toaster: "b-toaster-bottom-left",
            solid: true,
          }
        );

        return;
      }

      this.outletInformation.forEach((item) => {
        this.storeid = item.store_id;

        //alert(this.storeid)
      });

      if (this.newpwd == "" || this.otp == "" || this.conpwd == "") {
        // this.error_show = "All fields are required. Please fill all data"
      } else {
        this.error_show = "";

        let currentObj = this;
        currentObj.userdata = {
          store_id: this.storeid,
          phone: this.loginwithmobilenumber,
          new_password: this.newpwd,
          otp: this.otp,
        };

        currentObj.axios
          .post("forgotpswd", currentObj.userdata)
          .then(function (response) {
            let status = JSON.stringify(response.data.status);
            if (status == 200) {
              localStorage.setItem(
                "userinfo",
                JSON.stringify(response.data.custinfo)
              );
              // currentObj.$router.push("/ViewCartComponent").catch(()=>{});

              currentObj.$cookie.set(
                "test",
                JSON.stringify(response.data.custinfo),
                1
              );

              //currentObj.userinfolocal = JSON.parse(localStorage.getItem('userinfo'))

              currentObj.$bvModal.hide("modal-sm-login");
              currentObj.$bvToast.toast(response.data.msg, {
                variant: "success",
                toaster: "b-toaster-bottom-left",
                solid: true,
              });
            }

            if (status == 404) {
              currentObj.formShow = "signup";
              currentObj.$store.dispatch("setFormName", "signup");
              currentObj.$bvToast.toast(response.data.msg, {
                variant: "danger",
                toaster: "b-toaster-bottom-left",
                solid: true,
              });
            }

            if (status == 204) {
              // currentObj.formShow = 'signup'

              currentObj.$bvToast.toast(response.data.msg, {
                variant: "danger",
                toaster: "b-toaster-bottom-left",
                solid: true,
              });
            }

            if (status == 401) {
              // currentObj.formShow = 'signup'

              currentObj.$bvToast.toast(response.data.msg, {
                variant: "danger",
                toaster: "b-toaster-bottom-left",
                solid: true,
              });
            }
          })
          .catch((error) => {
            //this.errorMessage = error.message;
            // alert("There was an error! "+ error);

            console.log(error);
          });
      }
    },

    changePassword () {
      if (this.change_pass_otp == "" || this.change_pass_otp == undefined) {
        this.$bvToast.toast("Please enter received otp", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      if (
        this.change_pass_newpwd == "" ||
        this.change_pass_newpwd == undefined
      ) {
        this.$bvToast.toast("Please enter new password", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      if (
        this.change_pass_conpwd == "" ||
        this.change_pass_conpwd == undefined
      ) {
        this.$bvToast.toast("Please enter confirm password", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      if (this.change_pass_newpwd != this.change_pass_conpwd) {
        this.$bvToast.toast(
          "New password and confirm password should be same",
          {
            variant: "danger",
            toaster: "b-toaster-bottom-left",
            solid: true,
          }
        );

        return;
      }

      this.outletInformation.forEach((item) => {
        this.storeid = item.store_id;

        //alert(this.storeid)
      });

      if (
        this.change_pass_newpwd == "" ||
        this.change_pass_otp == "" ||
        this.change_pass_conpwd == ""
      ) {
        // this.error_show = "All fields are required. Please fill all data"
      } else {
        this.error_show = "";

        let currentObj = this;
        currentObj.userdata = {
          store_id: this.storeid,
          phone: this.loginwithmobilenumber,
          new_password: this.change_pass_newpwd,
          otp: this.change_pass_otp,
        };

        currentObj.axios
          .post("forgotpswd", currentObj.userdata)
          .then(function (response) {
            let status = JSON.stringify(response.data.status);
            if (status == 200) {
              localStorage.setItem(
                "userinfo",
                JSON.stringify(response.data.custinfo)
              );
              // currentObj.$router.push("/ViewCartComponent").catch(()=>{});

              currentObj.$cookie.set(
                "test",
                JSON.stringify(response.data.custinfo),
                1
              );

              //currentObj.userinfolocal = JSON.parse(localStorage.getItem('userinfo'))
              currentObj.$bvModal.hide("modal-sm-login");
              currentObj.$bvToast.toast(response.data.msg, {
                variant: "success",
                toaster: "b-toaster-bottom-left",
                solid: true,
              });
            }

            if (status == 404) {
              currentObj.formShow = "signup";
              currentObj.$store.dispatch("setFormName", "signup");
              currentObj.$bvToast.toast(response.data.msg, {
                variant: "danger",
                toaster: "b-toaster-bottom-left",
                solid: true,
              });
            }

            if (status == 204) {
              // currentObj.formShow = 'signup'

              currentObj.$bvToast.toast(response.data.msg, {
                variant: "danger",
                toaster: "b-toaster-bottom-left",
                solid: true,
              });
            }

            if (status == 401) {
              // currentObj.formShow = 'signup'

              currentObj.$bvToast.toast(response.data.msg, {
                variant: "danger",
                toaster: "b-toaster-bottom-left",
                solid: true,
              });
            }
          })
          .catch((error) => {
            //this.errorMessage = error.message;
            // alert("There was an error! "+ error);

            console.log(error);
          });
      }
    },

    openModal () {
      // alert("In Open Modal")

      //  this.formShow = localStorage.getItem('formname')
      //alert("In Open Modal "+this.formShow)
      //this.$bvModal.show('modal-sm-login')

      this.signupform.user_name = "";
      this.signupform.user_mobile_number = "";
      this.signupform.user_address = "";
      this.signupform.password = "";
      this.signupform.confirm_password = "";
      this.signupform.user_dob = "";
      this.signupform.user_anniversary = "";

      this.updatename = "";
      this.updateaddress = "";
      this.user_mobile_otp = "";
      this.otp = "";
      this.verifycustregi = "";
      this.loginwithmobilenumber = "";
      this.loginwithpass = "";
      this.newpwd = "";
      this.conpwd = "";

      this.openModalLogin();
    },

    setPlace (place) {
      // alert(place);

      this.signupform.user_address = place.formatted_address;
    },
  },
  mounted () {
    //alert("In mounted")
    // this.assignUserValue()
    //this.userinfolocal = JSON.parse(localStorage.getItem('userinfo'))
    //  alert("User Info is " + JSON.stringify(this.userinfolocal))
  },
  created () {
    // console.log("Helloo in created")
    this.outletInformation.forEach((item) => {
      // console.log("Helloo in for loop")
      this.verify_otp_while_registration =
        item.digital_ordering_settings.customer.verify_otp_while_registration;

      this.ask_dob_while_registration =
        item.digital_ordering_settings.customer.ask_dob_while_registration;

      this.ask_anniversary_while_registration =
        item.digital_ordering_settings.customer.ask_anniversary_while_registration;

      // this.logo = item.logo
      this.login_method = item.digital_ordering_settings.customer.login_method;
      this.ask_email_while_registration =
        item.digital_ordering_settings.customer.ask_email_while_registration;

      this.email_login = item.digital_ordering_settings.customer.email_login;
    });

    // alert("hello "+ this.login_method)

    //alert("Helloo form show is "+this.formShow)

    //alert("Hi "+this.formShow)

    //alert("Create "+this.$cookie.get('test'))

    if (this.$cookie.get("test") != null) {
      localStorage.setItem("userinfo", this.$cookie.get("test"));
      this.userinfolocal = JSON.parse(this.$cookie.get("test"));
      //alert("set cookies "+JSON.stringify(this.userinfolocal))
    }
  },
};
</script>